import { render, staticRenderFns } from "./MaterialReward.vue?vue&type=template&id=c9ed813c&scoped=true"
import script from "./MaterialReward.vue?vue&type=script&lang=js"
export * from "./MaterialReward.vue?vue&type=script&lang=js"
import style0 from "./MaterialReward.vue?vue&type=style&index=0&id=c9ed813c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ed813c",
  null
  
)

export default component.exports